<template>
    <div class="assignment-default-list-example">
        <div class="list-items">
            <div
                class="list-item"
                v-for="item in partIn.list_items"
                :key="item.id">
                <div class="list-item-header">
                    <design-2021-assignment-edit-type-assignment-part-list-item-component
                        :can-edit-portfolio="canEditPortfolio"
                        :item-in="item">
                    </design-2021-assignment-edit-type-assignment-part-list-item-component>
                </div>

                <div class="list-item-example">
                    <b-form-select
                        class="apprentice-primary-select assignment-edit-select"
                        :options="options"
                        :value="null"
                        readonly>
                    </b-form-select>
                </div>

                <b-button
                    class="btn-remove btn-remove-question"
                    v-if="canEditPortfolio"
                    v-b-tooltip.hover
                    variant="danger-icon-only"
                    title="Verwijderen"
                    :disabled="partIn.list_items.length === 1"
                    @click="deleteItem(item)">
                </b-button>
            </div>
        </div>

        <div
            class="new-list"
            v-if="canEditPortfolio">
            <design-2021-assignment-edit-type-assignment-part-list-question-component :part-in="partIn">
            </design-2021-assignment-edit-type-assignment-part-list-question-component>

            <div class="add-answer">
                <b-button
                    class="btn-edit btn-new-answer-option"
                    v-b-modal="'assignment-edit-answer-options-modal-' + partIn.id"
                    variant="primary"
                    @click="showEditModal()">
                    {{ $t('assignment.edit_answer_options') }}
                </b-button>
            </div>
        </div>

        <design-2021-assignment-edit-answer-options-modal
            ref="answer-option-modal"
            :ords="true"
            :part-in="partIn">
        </design-2021-assignment-edit-answer-options-modal>
    </div>
</template>

<script>
    import { CommonBus } from '../../../../../../app';

    export default {
        name: 'design-2021-assignment-edit-type-assignment-part-standardlist-component',
        props: {
            partIn: Object,
            canEditPortfolio: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                questionTitle: [],
            };
        },
        computed: {
            options() {
                let rawOptions = this.partIn.list_options.map((listOption) => {
                    return {
                        value: listOption.id,
                        text: listOption.value,
                    };
                });

                rawOptions.unshift({ value: null, text: 'Maak een keuze' });
                return rawOptions;
            },
        },

        created() {
            for (const name of this.partIn.list_items) {
                this.questionTitle.push({ edit: false });
            }
        },

        methods: {
            showEditModal() {
                this.$bvModal.show(`assignment-edit-answer-options-modal-${this.partIn.id}`);
            },

            updateQuestionTitle(value, item) {
                this.$emit('call-update-item', value, item);
            },

            deleteItem(item) {
                this.$emit('call-delete-item', item);
            },

            editQuestion() {
                CommonBus.$emit('enable-edit-mode');
            },
        },
    };
</script>

<style scoped lang="scss">
    .assignment-default-list-example {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        row-gap: $grid-gutter-width;
    }

    .list-items {
        .list-item {
            display: flex;
            flex: 1 0;
            flex-wrap: wrap;
            flex-direction: row;
            gap: map-get($grid-gutter-spacing, 'fifteen');

            &:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }
        }

        .list-item-header {
            flex: 1 0 100%;
            display: flex;
            justify-content: space-between;
            align-items: baseline;

            .context-assignment-default-list-nav ::v-deep {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');

                .assignment-default-list-nav {
                    .dropdown-menu {
                        border: 1px solid $border-color;
                    }

                    .remove-assignment-default-list-part {
                        font-size: $default-font-size;

                        .dropdown-item {
                            display: flex;
                            align-items: center;

                            i {
                                margin-right: map-get($grid-gutter-spacing, 'eight');
                                font-size: $base-font-size;
                            }
                        }
                    }
                }
            }
        }

        .list-item-example {
            width: calc(100% - 45px);
        }

        select {
            margin: 0;
            border: 1px solid $border-color;
        }
    }

    .new-list {
        display: flex;
        flex-direction: column;
        row-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .btn-remove-question {
        align-items: center;
        font-size: 1.3125rem;
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
        .new-list {
            flex-direction: column;
            justify-content: flex-start;

            .new-question,
            .btn-new-answer-option {
                width: auto;
            }

            .btn-new-answer-option {
                margin-top: 0;
                align-self: flex-start;
            }
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'xl')) {
        .list-items {
            .list-item {
                gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;
            }
            .list-item-header {
                flex: 0 0 auto;
                width: calc(50% - 42px);
            }
        }

        .assignment-default-list-example {
            flex-wrap: nowrap;
        }

        .list-item {
            .list-item-example {
                width: calc(50% - 45px);
            }
        }

        .new-list {
            flex-direction: row;
            justify-content: flex-start;
            column-gap: $grid-gutter-width;

            .new-question {
                width: calc(50% - 42px);
            }

            .add-answer {
                width: calc(50% - 15px);
                align-self: flex-end;
            }

            .btn-new-answer-option {
                width: auto;
            }
        }
    }
</style>
